





















import { Mode } from '../enums'
import { SanMove } from '../types'
import Analysis from '../analysis/models/analysis'
import Variation from '../analysis/models/variation'

export default {
  methods: {
    closeModal() {
      this.$store.dispatch(`setMode`, Mode.Normal)
    },
    gotoMove(variationPositionIndex: number) {
      this.$store.dispatch(`setVariationPositionIndex`, variationPositionIndex)
    }
  },

  computed: {
    inNormalMode(): boolean {
      return this.$store.state.mode === Mode.Normal
    },
    currentAnalysis(): Analysis {
      return this.$store.state.currentAnalysis
    },
    currentAnalysisVariation(): Variation {
      return this.$store.getters.currentAnalysisVariation
    },
    analysisMoves(): Array<SanMove> {
      if (!this.currentAnalysis || !this.currentAnalysisVariation) {
        return []
      }
      return this.currentAnalysisVariation.moves
    },
    startPlyNum(): number {
      return this.$store.state.positionIndex
    },
    startMoveNum(): number {
      return Math.round( this.startPlyNum / 2 )
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/modal_move_list.vue